/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `mesg_capabilities` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class MesgCapabilitiesMesg : Mesg {
    public constructor() : super("MesgCapabilities", Profile.MesgNum.MESG_CAPABILITIES)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** file. */
    public var file: File?
        get() = (getFieldValue(FILE_FIELD_NUM) as? UByte)?.let { File.fromValue(it) }
        set(value) = setFieldValue(FILE_FIELD_NUM, value?.value)

    /** mesg_num. */
    public var mesgNum: MesgNum?
        get() = (getFieldValue(MESG_NUM_FIELD_NUM) as? UShort)?.let { MesgNum.fromValue(it) }
        set(value) = setFieldValue(MESG_NUM_FIELD_NUM, value?.value)

    /** count_type. */
    public var countType: MesgCount?
        get() = (getFieldValue(COUNT_TYPE_FIELD_NUM) as? UByte)?.let { MesgCount.fromValue(it) }
        set(value) = setFieldValue(COUNT_TYPE_FIELD_NUM, value?.value)

    /** count. */
    public var count: UShort?
        get() = getFieldValue(COUNT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(COUNT_FIELD_NUM, value)

    /**
     * num_per_file: what count means when this message selects it.
     */
    public val numPerFile: UShort?
        get() = getFieldValue(COUNT_FIELD_NUM, 0, SubFieldSelector.Named("NumPerFile")) as? UShort

    public fun setNumPerFile(value: UShort?) {
        setFieldValue(COUNT_FIELD_NUM, value, 0, SubFieldSelector.Named("NumPerFile"))
    }

    /**
     * max_per_file: what count means when this message selects it.
     */
    public val maxPerFile: UShort?
        get() = getFieldValue(COUNT_FIELD_NUM, 0, SubFieldSelector.Named("MaxPerFile")) as? UShort

    public fun setMaxPerFile(value: UShort?) {
        setFieldValue(COUNT_FIELD_NUM, value, 0, SubFieldSelector.Named("MaxPerFile"))
    }

    /**
     * max_per_file_type: what count means when this message selects it.
     */
    public val maxPerFileType: UShort?
        get() = getFieldValue(COUNT_FIELD_NUM, 0, SubFieldSelector.Named("MaxPerFileType")) as? UShort

    public fun setMaxPerFileType(value: UShort?) {
        setFieldValue(COUNT_FIELD_NUM, value, 0, SubFieldSelector.Named("MaxPerFileType"))
    }

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val FILE_FIELD_NUM: UByte = 0u
        public const val MESG_NUM_FIELD_NUM: UByte = 1u
        public const val COUNT_TYPE_FIELD_NUM: UByte = 2u
        public const val COUNT_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("File", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("MesgNum", 1u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[2] = Field("CountType", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("Count", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
                .addSubField(
                    SubField("NumPerFile", BaseType.UINT16, 1.0, 0.0, "").also { subField ->
                        subField.addMap(2u, 0)
                    },
                )
                .addSubField(
                    SubField("MaxPerFile", BaseType.UINT16, 1.0, 0.0, "").also { subField ->
                        subField.addMap(2u, 1)
                    },
                )
                .addSubField(
                    SubField("MaxPerFileType", BaseType.UINT16, 1.0, 0.0, "").also { subField ->
                        subField.addMap(2u, 2)
                    },
                )
            return fields
        }
    }
}
